import ApiService from '../api.service';

const BankAccountResource = {
  create: (params) => ApiService.post(`/v1/business/${params.business_id}/bank_accounts`, params),
  index: (params) => ApiService.get(`/v1/business/${params.business_id}/bank_accounts`),
};

export default BankAccountResource;
